import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonSectionFn = /* @__PURE__ */ createRecipe('button-section', {}, [])

const buttonSectionVariantMap = {}

const buttonSectionVariantKeys = Object.keys(buttonSectionVariantMap)

export const buttonSection = /* @__PURE__ */ Object.assign(memo(buttonSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonSection',
  __getCompoundVariantCss__: buttonSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonSectionVariantKeys,
  variantMap: buttonSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonSectionVariantKeys)
  },
  getVariantProps: buttonSectionFn.getVariantProps,
})